<template>
	<div>		
		<template v-for="(item,index) in dataList">
			<el-menu-item v-if="!item.child" :key="item.id" :index="item.href">
				<i :class="[item.icon ? item.icon : '']"></i>
				<span slot="title">{{ item.title }}</span>
			</el-menu-item>
			<el-submenu  v-else :key="item.id" :index="item.id+''">
				<template slot="title">
					<i :class="[item.icon ? item.icon :'']"></i>
					<span>{{ item.title }}</span>
				</template>				
				<MenuTree :dataList="item.child"></MenuTree>				
			</el-submenu>
		</template>	
	</div>
</template>
<script>
	import base from '../api/base.js'
	import store from '../store'
	export default {
		name: 'MenuTree', // 很重要，调用自身需要用到
		props: ['dataList',"isCollapse"],
		data() {
			return {
				menu: store.state.menuModule.dymenuList,
				title: store.state.menuModule.logoInfo.logotitle,
				logo: store.state.menuModule.logoInfo.logo,
			}
		},
		mounted() {},
		methods: {},
		}
</script>
<style lang='less' scoped>
	 .el-menu {
		border-right: 0;
	} 
	.el-logo{
		height: 60px;
	}
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}
</style>